<template>
  <div class="maincen">
    <div class="catalog">
      <div class="catalogTit">申请样书列表</div>
    </div>
    <div class="center">
      <ul class="bookMajorul">
        <li v-for="(information, index) in textbook" :key="index">
          <img class="majorImg" :src="information.coverUrl" alt="" />
          <div class="majorRight">
            <p class="bookTitle">{{ information.teachName }}</p>
            <p class="commoncss">
              作者:<span class="ml">{{ information.author }}</span>
            </p>
            <p class="commoncss">
              书号:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ information.isbn }}
            </p>
            <p class="commoncss">出版社:{{ information.platformName }}</p>
            <p class="commoncss">
              定价:&nbsp;&nbsp; <span class="pricecolor"
                >￥{{ information.pricing.toFixed(2) }}</span
              >
            </p>
            <p class="commoncss">
              审核状态:&nbsp;&nbsp; <span class="ml" :style="`color:${statusColors[information.stylebookAuditType]}`" >{{status[information.stylebookAuditType]}}</span> 
            </p>
            <!-- <div  class="bottom"> -->
              <el-popover
                placement="bottom-start"
                width="600"
                trigger="click">
                 <!-- @click="showDetailclick(information.id)" -->
                 <div>
                   <ul class="detailul" v-if="detailObj != {}">
                      <li > 申请状态: {{status[detailObj.stylebookAuditType]}}</li>
                      <li v-show="detailObj.stylebookAuditType == 2">货单号: {{detailObj.ems}}</li>
                      <!-- <li>姓&nbsp;&nbsp;名: {{ image.name }}</li> -->
                      <li>学&nbsp;&nbsp;校: {{ detailObj.schoolName }}</li>
                      <li>职&nbsp;&nbsp;称: {{ getzhichengStr(parseInt(detailObj.professional)) }}</li>
                      <li>手&nbsp;&nbsp;机: {{ detailObj.mobilephone }}</li>
                      <li>样书数量: {{ detailObj.stylebookNumber }}本</li>
                      <li>预计用书量: {{ detailObj.anticipatedNumber }}本</li>
                      <li style="width:100%" v-show="detailObj.stylebookAuditType == 3 && detailObj.refusalCase != ''">拒绝原因: {{detailObj.refusalCase}}</li>
                      <li style="width:100%">寄送地址: {{ detailObj.address }}</li>
                      <li v-if="detailObj.description != ''" style="width:100%;">备&nbsp;&nbsp;注:  {{ detailObj.description}}</li> 
                   </ul>
                 </div>
                <div slot="reference" class="divcard" @click="showDetailclick(information.id)">
                  <img class="iconimg" src="../../assets/img/lookicon_def.png" alt="">
                  <span>查看详情</span>
                </div>
                
              </el-popover>
            <!-- </div> -->
                  <modelDetail
                    :sonValue="detailObj"
                    @close="close"
                    v-show="showDetail"
                  ></modelDetail>
          </div>
        </li>
      </ul>
      
    </div>
  </div>
</template>
<script>
import { getzhichengStr } from '../../assets/tool';
import { api } from '../../assets/api/axios'
import { fetchSmapleBookList,fetchSmapleBookDetail } from '../../api/wapi'
import { mapMutations, mapState, mapGetters } from 'vuex'
import { baseUrl } from '@/config.js'
import modelDetail from '../common/modelDetail.vue'
export default {
  data() {
    return {
      textbook: {},
      getzhichengStr:getzhichengStr,
      showDetail: false,
      detailObj: {},
      statusColors:{
        1:'#FF9A2B',
        2:"#0FBA9B",
        3:"#B31616"
      },
      status:{
        1:"待处理",
        2:"已处理",
        3:"已拒绝"
      }
    }
  },
  components: {
    modelDetail,
  },
  created() {
    this.getSelectSampleBook()
  },
  methods: {
    getSelectSampleBook() {
      fetchSmapleBookList()
        .then((res) => {
            this.textbook = res&&res.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    showDetailclick(id) {
      // this.showDetail = true
      fetchSmapleBookDetail(id)
        .then((res) => {
            this.detailObj = res.data
        })
        .catch(() => {
          console.log(error)
        })
    },
    close() {
      this.showDetail = false
    },
  },
}
</script>
<style lang="scss" scoped>
.maincen{
  background-color: white;
  padding: 0px 20px;
}
.popoverul {
  padding: 10px 20px;
}
.popoverul li {
  width: 33.33%;
  float: left;
}
.detailul{
  // height: 200px;
}
.detailul li {
  width:33.3%;
  float: left;
  line-height: 40px;
}
.center {
  width:100%;
  height: 100%;
  margin-top: 20px;
}
.iconimg{
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 10px;
}
.divcard {
  width: 132px;
  color: #0082F0;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.pricecolor {
  color: #B80D03;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 24px;
}
.commoncss {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
.bookTitle {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 5px;
  overflow:hidden;
  width: 180px;
  text-overflow:ellipsis;
  white-space:nowrap;
}
.majorImg {
  width: 130px;
  height: 181px;
  object-fit: cover;
}
.majorRight {
  margin-left: 10px;
}
.bookMajorul{
  display: flex;
  flex-wrap: wrap;
  padding: 0px;
}
.bookMajorul li {
  width:330px;
  padding: 20px;
  height: 181px;
  margin-bottom: 20px;
  display: flex;
}
.bookMajorul li:nth-last-child(3n+1){
  margin: 0px 25px;
}
.catalog{
  padding: 20px 0px 5px;
  border-bottom: 1px solid #e6e6e6;
}
.catalogTit{
  font-size: 18px;
  width: 100%;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  text-align: center;
}
.itemnewImg {
  margin-top: 10px;
  width: 100%;
  height: 117px;
  img {
    height: 100%;
    width: 100%;
  }
}
.bottom{
  display: flex;
  justify-content: flex-start;
  align-items: center;

}
.addImg {
  margin-top: 10px;
  width: 185px;
  height: 117px;
  margin-bottom: 60px;
  img {
    height: 100%;
    width: 100%;
  }
}
.itemTit {
  font-size: 16px;
  color: #0082F0;
  margin: 17px 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 30px;
  cursor: pointer;
  &:hover {
    color: #0082F0;
  }
}
.preserve {
  width: 100px;
  height: 36px;
  background: #0082F0;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 36px;
  margin: 50px 0 80px;
  cursor: pointer;
}
.head {
  overflow: hidden;
  padding-left: 17px;
  :nth-child(1) {
    float: left;
    font-size: 14px;
    color: #606266;
    // margin-left: 17px;
    line-height: 80px;
    // height: 80px;
  }
  :nth-child(2) {
    float: left;
  }
}
.phonesend {
  width: 150px;
  height: 37px;
  background: rgba(252, 252, 252, 1);
  border-left: 1px solid rgba(230, 230, 230, 1);
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  text-align: center;
  line-height: 38px;
  position: absolute;
  top: 3px;
  right: 188px;
  cursor: pointer;
}
</style>
<style lang="scss">
@import '../../assets/css/centertabs.scss';

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-left: 10px;
  // border-radius: 50%;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px !important;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px !important;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>
